import type { UserOption, UserId } from '@atlassian/jira-base-user-picker/src/types.tsx';
import type { AvatarUrls } from '@atlassian/jira-shared-types/src/rest/jira/user.tsx';
import { PEOPLE_FIELD_MUTATION_GROUP } from './constants.tsx';
import type { JiraPeopleFieldInput } from './types.tsx';

export const mutatePeopleField = (
	selectedValue: UserOption | UserOption[],
	fieldId: string,
): JiraPeopleFieldInput => ({
	fieldId,
	mutationGroup: PEOPLE_FIELD_MUTATION_GROUP,
	users: Array.isArray(selectedValue)
		? selectedValue.map(
				(
					user: UserOption,
				): {
					accountId: string;
				} => ({
					accountId: user.id,
				}),
			)
		: [
				{
					accountId: selectedValue.id,
				},
			],
});

export const mapUserOptionOrOptionsToIds = (
	userOption: UserOption | UserOption[],
): UserId | UserId[] => {
	if (Array.isArray(userOption)) {
		return userOption.map<UserId>((option) => ({
			id: option.id,
		}));
	}
	return [
		{
			id: userOption.id,
		},
	];
};

export const transformToUserOption = (userData: {
	accountId: string;
	displayName?: string;
	avatarUrl?: string;
	avatarUrls?: AvatarUrls;
}): {
	id: string;
	name: string;
	avatarUrl: string;
} => ({
	id: userData.accountId,
	name: userData.displayName || '',
	avatarUrl: userData.avatarUrl || userData.avatarUrls?.['32x32'] || '',
});
